export default "__VITE_ASSET__Ctz7Dtfv__"